import { useMutation } from "@tanstack/react-query";
import { share } from "@utils/links/share";

export const useShare = () =>
  useMutation({
    mutationFn: share,
  });
